import { DropdownMenu } from 'vopay';
import { useTranslation } from 'react-i18next';
import { UtilButton } from '#shared/components/UI';

export type TransactionExportType = 'pdf' | 'csv' | 'xls' | 'doc' | 'text' | 'json' | 'xml' | 'print';

type TransactionsExportProps = {
  onExport: (type: TransactionExportType) => void;
};

export default function TransactionsExport({ onExport }: TransactionsExportProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.TransactionHistory.TransactionSearchForm' });

  const exportOptions: { id: string; label: string; type: TransactionExportType }[] = [
    { id: 'export-PDF-btn', label: t('ExportDd.pdf', { defaultValue: 'PDF' }), type: 'pdf' },
    { id: 'export-CSV-btn', label: t('ExportDd.csv', { defaultValue: 'CSV' }), type: 'csv' },
    { id: 'export-XLS-btn', label: t('ExportDd.xls', { defaultValue: 'XLS' }), type: 'xls' },
    { id: 'export-DOC-btn', label: t('ExportDd.doc', { defaultValue: 'DOC' }), type: 'doc' },
    { id: 'export-Text-btn', label: t('ExportDd.text', { defaultValue: 'Text' }), type: 'text' },
    { id: 'export-JSON-btn', label: t('ExportDd.json', { defaultValue: 'JSON' }), type: 'json' },
    { id: 'export-XML-btn', label: t('ExportDd.xml', { defaultValue: 'XML' }), type: 'xml' },
    { id: 'export-Print-btn', label: t('ExportDd.print', { defaultValue: 'Print' }), type: 'print' },
  ];

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <UtilButton data-testid="export-transactions" iconLeft="download">
          {t('ExportDd.export', { defaultValue: 'Export' })}
        </UtilButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content align="end">
        {exportOptions.map(({ id, label, type }) => (
          <DropdownMenu.Item
            key={id}
            onSelect={() => {
              onExport(type);
            }}
          >
            {label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
}
